export default __webpack_public_path__ + "static/media/bg-polisport-usa.d86524fe.png";